import { encodeUrlState, URL_STATE_PARAM } from "@/common/helpers/url-state";
import { DEFAULT_TAB_STATE_KEY } from "@/components/detail-page/detail-tabs";

export function buildDetailTabSearch(tabId: string, stateKey = DEFAULT_TAB_STATE_KEY): string {
  const viewState = encodeUrlState({ [stateKey]: tabId });

  return viewState ? `?${URL_STATE_PARAM}=${viewState}` : "";
}
